// extracted by mini-css-extract-plugin
module.exports = {"wrap":"list_wrap__aqPrP","sectionTit":"list_sectionTit__1tDb-","footer":"list_footer__3ht8b","tabs":"list_tabs__3SDMI"};